import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
export const StyledSignalText = styled.div`
    ${mixins.setFontVariant("tab", colorsPalettes.carbon[400])};
    font-weight: 400;
    margin-bottom: 16px;

    &:first-letter {
        text-transform: capitalize;
    }
`;

export const StyledSignalTextBold = styled.span`
    ${mixins.setFontVariant("tab", colorsPalettes.carbon[400])};
`;

export const StyledSignalTooltipText = styled.div`
    ${mixins.setFontVariant("tab", colorsPalettes.bluegrey[100])};
    font-weight: 400;
    line-height: 20px;
`;

export const StyledSignalPartialText = styled.div`
    margin-bottom: 8px;

    span {
        ${mixins.setFontVariant("tab", colorsPalettes.carbon[400])};
        font-weight: 400;
    }
`;

export const StyledSignalCompanyLink = styled.a`
    color: ${colorsPalettes.carbon[400]};
    text-decoration: underline;

    &:hover {
        color: ${colorsPalettes.blue[400]};
    }
`;
